(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('auto-slideshow')) {
    customElements.define(
      'auto-slideshow',
      class AutoSlideshow extends HTMLElement {
        constructor() {
          super();
          this.currentIndex = 0;
          this.img = this.querySelector('img');

          try {
            this.slides = JSON.parse(this.getAttribute('data-images') || '[]');
          } catch (e) {
            this.slides = [];
          }

          this.canAutoPlay = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

          if (this.canAutoPlay && this.slides.length > 1 && this.img) {
            this.startSlideshow();
          }
        }

        startSlideshow() {
          this.interval = setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.slides.length;
            const slide = this.slides[this.currentIndex];
            // Directly swap src — no opacity change, no blank frame
            this.img.src = slide.src;
            if (slide.srcset) this.img.srcset = slide.srcset;
            if (slide.alt !== undefined) this.img.alt = slide.alt;
          }, 2500);
        }

        disconnectedCallback() {
          if (this.interval) clearInterval(this.interval);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
